// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3514u","top":"styles_top__1nM9S"};